var React = require('react');

function IconArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(19.627 19.627) rotate(180)"},[React.createElement("rect",{"width":"19.627","height":"19.627","fill":"#6d28d9","stroke":"rgba(0,0,0,0)","opacity":"0","key":0}),React.createElement("path",{"fill":"#6d28d9","d":"M12.954,5.659V7.295H3.14l4.5,4.5L6.477,12.954,0,6.477,6.477,0,7.638,1.161l-4.5,4.5Z","transform":"translate(3.271 3.271)","key":1})]));
}

IconArrowLeft.defaultProps = {"width":"19.627","height":"19.627","viewBox":"0 0 19.627 19.627"};

module.exports = IconArrowLeft;

IconArrowLeft.default = IconArrowLeft;
